/* Autoplay muted product videos when visible (some browsers ignore the autoplay attribute) */
(function () {
  var vids = document.querySelectorAll('.av-videos video');
  if (!vids.length) return;
  var play = function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) play(e.target); else e.target.pause(); });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  } else { vids.forEach(play); }
})();
